 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		3: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		3: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"4ff8ec93074b8d23e5e7447fd79019a8bbff0900","2":"bac1b955","5":"component---src-analytics-mdx","6":"component---src-api-integration-mdx","7":"component---src-available-script-command-admin-scripts-mdx","8":"component---src-available-script-command-api-command-mdx","9":"component---src-available-script-command-shop-scripts-mdx","10":"component---src-backend-integration-mdx","11":"component---src-contact-mdx","12":"component---src-customization-customization-mdx","13":"component---src-customization-new-page-mdx","14":"component---src-customization-styles-and-assets-mdx","15":"component---src-customization-utilities-mdx","16":"component---src-data-fetching-mdx","17":"component---src-demo-deploy-mdx","18":"component---src-deployment-aws-mdx","19":"component---src-deployment-cpanel-mdx","20":"component---src-deployment-re-build-admin-mdx","21":"component---src-deployment-re-build-shop-mdx","22":"component---src-deployment-vercel-mdx","23":"component---src-deployment-virtual-private-server-automated-mdx","24":"component---src-deployment-virtual-private-server-manual-mdx","25":"component---src-email-configuration-mdx","26":"component---src-faq-mdx","27":"component---src-faq-page-mdx","28":"component---src-features-analytic-mdx","29":"component---src-features-ecommerce-mdx","30":"component---src-features-feature-intro-mdx","31":"component---src-features-feedback-mdx","32":"component---src-features-layout-mdx","33":"component---src-features-mdx","34":"component---src-features-order-mdx","35":"component---src-features-products-mdx","36":"component---src-features-shop-mdx","37":"component---src-features-tooltip-mdx","38":"component---src-features-user-mdx","39":"component---src-getting-started-mdx","40":"component---src-index-mdx","41":"component---src-integrations-open-ai-integration-mdx","42":"component---src-laravel-api-mdx","43":"component---src-multilingual-translation-multilingual-mdx","44":"component---src-multilingual-translation-translation-mdx","45":"component---src-pages-404-js","46":"component---src-payment-bitpay-mdx","47":"component---src-payment-coinbase-mdx","48":"component---src-payment-integratioin-new-payment-gateway-mdx","49":"component---src-payment-introduction-mdx","50":"component---src-payment-mollie-mdx","51":"component---src-payment-paypal-mdx","52":"component---src-payment-paystack-mdx","53":"component---src-payment-razorpay-mdx","54":"component---src-payment-stripe-mdx","55":"component---src-seo-mdx","56":"component---src-settings-company-information-mdx","57":"component---src-settings-events-settings-mdx","58":"component---src-settings-general-settings-mdx","59":"component---src-settings-maintenance-setting-mdx","60":"component---src-settings-payment-settings-mdx","61":"component---src-settings-seo-settings-mdx","62":"component---src-settings-shop-settings-mdx","63":"component---src-support-mdx","64":"component---src-tech-we-have-used-mdx","65":"component---src-terms-and-conditions-mdx","66":"component---src-transfer-shop-shop-transfer-request-mdx","67":"component---src-transfer-shop-transfer-owner-mdx","68":"component---src-update-upgrade-guide-existing-project-update-mdx","69":"component---src-update-upgrade-guide-laravel-upgrade-mdx","70":"component---src-update-upgrade-guide-vps-update-mdx","71":"component---src-user-role-customer-mdx","72":"component---src-user-role-multivendor-mdx","73":"component---src-user-role-staff-mdx","74":"component---src-user-role-super-admin-mdx","75":"component---src-user-role-vendor-mdx","76":"component---src-versions-mdx","77":"component---src-wallet-mdx"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"c112f4bf32e23eaed271","2":"87994f8f243c3769bc95","5":"259d8779fe03938a3b29","6":"5c9c028abb2c32e33116","7":"0ef28fe002d7966cd097","8":"c1bed2f41c6e5e2aed18","9":"a784567402f7de30e385","10":"9d035520698d8f115ea6","11":"819176bf11f24378e9bc","12":"f31d5485c4b2acfb7d21","13":"1b18c5de9d795d7f2315","14":"504e1cf72f7e00941bfd","15":"f3bd85aa077d29a99bd3","16":"efe9280cc31fcfe2f814","17":"c6519792ea71be3cb8f4","18":"0c046433aafc5770108b","19":"8605f0a64506a931555a","20":"10337eac9beb5d3d971d","21":"40c1c718694c31f31447","22":"c7b3ce39d338d1d73459","23":"68dd0fc35fedf0e3e747","24":"2d7464c2539075bbb4ad","25":"a62238cdd9f0a322c6ec","26":"92568208cff0b10172ed","27":"65ef2870bc036a9685e1","28":"252d8cf2d8d281c99de4","29":"8e805f7608946d5f031f","30":"795caa3bd97a55847763","31":"cbddc8a65ccc114894a2","32":"b8ea8d1e3935d57a91df","33":"a01c30a9b131d1039ebc","34":"a75d9f1c2d363b72e375","35":"c95ba966b37a83dec318","36":"d72bd4562ca5a54aa905","37":"bfcdc030c1c5d045c66f","38":"8369dbbad3b1ca771edf","39":"a29f06f9ace389c352eb","40":"99f250bec4fecee2909b","41":"ad354f8fe6229ccaf51e","42":"f3c71078caab5f12c128","43":"15c2b23af0c3f777b7e5","44":"c5e900474fe9c9765e28","45":"6e97c426781bed70e7d5","46":"f185b67e38aa19c75611","47":"e919d9a49c66889f26a1","48":"54ae6abc0c79b8191313","49":"6c37aa1829c38063eaa6","50":"848934f275090b6680e1","51":"c61bd51d8e6ef5577be4","52":"f75aef0f250e72df1192","53":"5111a535e7d810279f7b","54":"46d7c9b95a46c8471a1d","55":"9839714fa24054b8dd92","56":"76a10b5153fcfdac4d36","57":"827ff65701eb86db4a03","58":"54698bd3f9b8cb560a82","59":"1c2094b547338cbcfdfb","60":"fc73c847a83a35962b8b","61":"9c9c391f883032a6f00a","62":"a40d04327a0f5aed7973","63":"463580e11357ff06e4fc","64":"da021a469dea5386f6e2","65":"94d7493c7cf9f8ccbddb","66":"cc58024067ba6347fdfa","67":"8cd804e32fe2c096eb0a","68":"8265efa62e9e9436f0e2","69":"f89c7b8e5d1de4e0d685","70":"243727ff5a3780201a7e","71":"8412d885908ec31a3eef","72":"585e27f2f0488e626e05","73":"2abb180263ae431ffb45","74":"dee3790fa526a178c40b","75":"6c184e005aa5ceb4b49e","76":"f4eedb11869cb74be9b9","77":"8e3c7b18774841a50ae1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"4ff8ec93074b8d23e5e7447fd79019a8bbff0900","2":"bac1b955","5":"component---src-analytics-mdx","6":"component---src-api-integration-mdx","7":"component---src-available-script-command-admin-scripts-mdx","8":"component---src-available-script-command-api-command-mdx","9":"component---src-available-script-command-shop-scripts-mdx","10":"component---src-backend-integration-mdx","11":"component---src-contact-mdx","12":"component---src-customization-customization-mdx","13":"component---src-customization-new-page-mdx","14":"component---src-customization-styles-and-assets-mdx","15":"component---src-customization-utilities-mdx","16":"component---src-data-fetching-mdx","17":"component---src-demo-deploy-mdx","18":"component---src-deployment-aws-mdx","19":"component---src-deployment-cpanel-mdx","20":"component---src-deployment-re-build-admin-mdx","21":"component---src-deployment-re-build-shop-mdx","22":"component---src-deployment-vercel-mdx","23":"component---src-deployment-virtual-private-server-automated-mdx","24":"component---src-deployment-virtual-private-server-manual-mdx","25":"component---src-email-configuration-mdx","26":"component---src-faq-mdx","27":"component---src-faq-page-mdx","28":"component---src-features-analytic-mdx","29":"component---src-features-ecommerce-mdx","30":"component---src-features-feature-intro-mdx","31":"component---src-features-feedback-mdx","32":"component---src-features-layout-mdx","33":"component---src-features-mdx","34":"component---src-features-order-mdx","35":"component---src-features-products-mdx","36":"component---src-features-shop-mdx","37":"component---src-features-tooltip-mdx","38":"component---src-features-user-mdx","39":"component---src-getting-started-mdx","40":"component---src-index-mdx","41":"component---src-integrations-open-ai-integration-mdx","42":"component---src-laravel-api-mdx","43":"component---src-multilingual-translation-multilingual-mdx","44":"component---src-multilingual-translation-translation-mdx","45":"component---src-pages-404-js","46":"component---src-payment-bitpay-mdx","47":"component---src-payment-coinbase-mdx","48":"component---src-payment-integratioin-new-payment-gateway-mdx","49":"component---src-payment-introduction-mdx","50":"component---src-payment-mollie-mdx","51":"component---src-payment-paypal-mdx","52":"component---src-payment-paystack-mdx","53":"component---src-payment-razorpay-mdx","54":"component---src-payment-stripe-mdx","55":"component---src-seo-mdx","56":"component---src-settings-company-information-mdx","57":"component---src-settings-events-settings-mdx","58":"component---src-settings-general-settings-mdx","59":"component---src-settings-maintenance-setting-mdx","60":"component---src-settings-payment-settings-mdx","61":"component---src-settings-seo-settings-mdx","62":"component---src-settings-shop-settings-mdx","63":"component---src-support-mdx","64":"component---src-tech-we-have-used-mdx","65":"component---src-terms-and-conditions-mdx","66":"component---src-transfer-shop-shop-transfer-request-mdx","67":"component---src-transfer-shop-transfer-owner-mdx","68":"component---src-update-upgrade-guide-existing-project-update-mdx","69":"component---src-update-upgrade-guide-laravel-upgrade-mdx","70":"component---src-update-upgrade-guide-vps-update-mdx","71":"component---src-user-role-customer-mdx","72":"component---src-user-role-multivendor-mdx","73":"component---src-user-role-staff-mdx","74":"component---src-user-role-super-admin-mdx","75":"component---src-user-role-vendor-mdx","76":"component---src-versions-mdx","77":"component---src-wallet-mdx"}[chunkId]||chunkId) + "." + {"0":"06e1d4f59ae154694c74","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
